import {
  createPrintError,
  PRINT_ERROR_CODES,
} from "../contracts";

export async function printTcpAdapter({ job }) {
  throw createPrintError(
    PRINT_ERROR_CODES.ADAPTER_UNAVAILABLE,
    "TCP Print Adapter belum diaktifkan.",
    {
      job,
      adapter: "tcp",
    }
  );
}
